module.exports = __webpack_public_path__ + "static/media/download.fc16620f.svg";